module.exports = __webpack_public_path__ + "static/media/banner.8da0981f.png";